import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ErrorServerModalComponent,
} from '@banyan/features/error/components/error-server-modal/error-server-modal.component';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export function errorServerInterceptor(req: HttpRequest<any>, next: HttpHandlerFn) {
  return _errorServerInterceptor(inject(MatDialog))(req, next);
}

export function _errorServerInterceptor(dialog: MatDialog) {
  const serverErrors = [500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 511];

  return (req: HttpRequest<any>, next: HttpHandlerFn) =>
    next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          serverErrors.includes(error.status) &&
          !error.url?.includes('/api/need-capture/notes/suggestions')
        ) {
          dialog.open(ErrorServerModalComponent);
        }
        return throwError(() => error);
      }),
    );
}
